import React from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Typography from '@mui/material/Typography';
import { Box, Link, Paper, Button, Divider, IconButton, Drawer, List, ListItem, ListItemText, Accordion, AccordionActions, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import InfoIcon from '@mui/icons-material/Info';
import Container from '../../../../../components/Container';
import Main from '../../../../../layouts/Main';
import { ClickAwayListener } from '@mui/base/ClickAwayListener';
import CloseIcon from '@mui/icons-material/Close';
import Grid from '@mui/material/Grid2';
import InfoItemBox from './InfoItemBox';
import { InfoItemBoxProps } from '../dataObjects/contentTypes';



const bankNames: string[] = [
    "Adams Community Bank",
    "Align Credit Union",
    "Amalgamated Bank",
    "Athol Savings Bank",
    "Bank Five",
    "Bank Gloucester",
    "Bank of America",
    "Bank of Labor",
    "bankESB",
    "BankProv",
    "Bay State Savings Bank",
    "Berkshire Bank",
    "Boston Firefighters Credit Union",
    "Bristol County Savings Bank",
    "Cape Ann Savings Bank",
    "Cape Cod 5",
    "Central One Federal Credit Union",
    "Citizens Bank",
    "Coastal Heritage Bank",
    "Community Credit Union",
    "Country Bank for Savings",
    "Dedham Savings",
    "East Cambridge Savings Bank",
    "Enterprise Bank & Trust",
    "Everett Bank",
    "Florence Bank",
    "Greenfield Savings Bank",
    "Greylock Federal Credit Union",
    "Hanscom Federal Credit Union",
    "Haverhill Bank",
    "Leader Bank",
    "Lending Club Bank",
    "Liberty Bay Credit Union",
    "Lowell Five Cent Savings Bank",
    "M & T Bank",
    "Main Street Bank",
    "Mechanics Cooperative Bank",
    "Millbury Federal Credit Union",
    "Mountain One Bank",
    "Mutual One Bank",
    "Needham Bank",
    "New Bedford Credit Union",
    "Northern Bank & Trust",
    "Polish National Credit Union",
    "Rockland Trust",
    "Saint Michael's Federal Credit Union",
    "Salem Five",
    "Santander",
    "Somerset Federal Credit Union",
    "Southcoast Health System Federal Credit Union",
    "St. Jean's Credit Union",
    "Taunton Federal Credit Union",
    "TD Bank",
    "The Cooperative Bank of Cape Cod",
    "The Pittsfield Cooperative Bank",
    "The Savings Bank",
    "The Village Bank",
    "Westfield Bank",
    "Winter Hill Bank",
    "Workers Credit Union"
  ];
  








const content: InfoItemBoxProps[] = [
  {
    title: 'Participating Banks in OCPF Depository Reporting System *',
    blocks: [
      {
        type: "list",
        listType: "bullet",
        items: bankNames.map(bank => ({
          content: [
            {
              type: "text",
              content: bank
            }
          ]
        }))
      },
      {
        type: 'paragraph',
        content: [
          {type: "text", content: "* If your bank is not in the above list, please contact OCPF (617-979-8300, ocpf@mass.gov) for more information." }
        ]
      }
      
    ]
  }
];


const BankList = (): JSX.Element => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });


  return (
    <div>

     {content.map((content, index) => (
      <InfoItemBox key={index} {...content} />
    ))}
  </div>
   
  );
};

export default BankList;
